export default "/images/ee5bae115a5e2935c04b46ab10152ad9.avif";